import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const ServiceDescription = () => {

  const companyDetail = useSelector((state) => state.companyReducer.company);
  const [company, setCompany] = useState(companyDetail);

  useEffect(() => {
    const companyData = companyDetail;
    if (companyData && companyData.description) {
      setCompany(companyData.description);
    }
  }, [companyDetail]);

  return (
    <div className="bg-gray-50 py-10 px-4">
      <div className="text-center mb-6">
        <h1 className="text-3xl font-bold text-gray-800">Company Description</h1>
      </div>

      <div className="rounded-lg p-6 mx-auto max-w-4xl">
        <div
          className="company-description text-gray-800 text-lg leading-relaxed text-center space-y-8"
          dangerouslySetInnerHTML={{ __html: company }}
        />
      </div>
    </div>
  );
};

export default ServiceDescription;
